export const PHONE_NUMBER = new RegExp(/^[6-9]\d{9}$/);
export const urlRegex = /(https?:\/\/[^\s)]+|www\.[^\s)]+)/g;